module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-metals.57b482a0.png";